import { ROUTE_ACCESS_MATRIX } from './routeAccessMatrix'

/**
 * Rutas visibles para PROD:Supervisor sin rol elevado (Manager, Process Engineer, HR admin).
 * People + Production + Process completos, más utilidades mínimas.
 */

/** Rutas de utilidad siempre permitidas (perfil, página de denegado). */
export const PROD_SUPERVISOR_UTILITY_PATHS = new Set([
  '/profile',
  '/acceso-denegado',
])

/** Production Management (Sidebar.jsx) — acceso completo del supervisor. */
export const PROD_SUPERVISOR_PRODUCTION_PATHS = new Set([
  '/ordenes-fabricacion',
  '/programacion',
  '/oee-metricas',
  '/materiales-consumos',
  '/lotes-trazabilidad',
  '/pda/sala-mezcla',
])

/** Process Management (Sidebar.jsx) — acceso completo del supervisor. */
export const PROD_SUPERVISOR_PROCESS_MODULE_PATHS = new Set([
  '/datos-maestros-procesos',
  '/parametros-procesos',
  '/bom-rutas',
  '/instrucciones-trabajo',
  '/events',
  '/energy',
])

/** People Management (Sidebar.jsx) — sin /empleados (solo RRHH y roles elevados de prod). */
export const PROD_SUPERVISOR_PEOPLE_PATHS = new Set([
  '/calendario-labor',
  '/asistencia',
  '/asignaciones',
  '/asignacion-personal',
  '/salidas-especiales',
  '/control-horas',
  '/evaluaciones',
])

/**
 * Rutas de Production/Process donde la matriz concede acceso a PROD:Operator.
 * @param {typeof ROUTE_ACCESS_MATRIX} matrix
 * @param {Set<string>} modulePaths
 * @returns {Set<string>}
 */
export function collectOperatorPathsInModules(matrix, modulePaths) {
  const paths = new Set()
  for (const row of matrix) {
    if (modulePaths.has(row.path) && row.roles?.['PROD:Operator'] === true) {
      paths.add(row.path)
    }
  }
  return paths
}

/** Rutas Process/Production que el operario puede ver (derivadas de la matriz). */
export const PROD_OPERATOR_ALIGNED_PATHS = new Set([
  ...collectOperatorPathsInModules(ROUTE_ACCESS_MATRIX, PROD_SUPERVISOR_PRODUCTION_PATHS),
  ...collectOperatorPathsInModules(ROUTE_ACCESS_MATRIX, PROD_SUPERVISOR_PROCESS_MODULE_PATHS),
])

/** Unión final para el supervisor acotado. */
export const PROD_SUPERVISOR_MODULE_PATHS = new Set([
  ...PROD_SUPERVISOR_PEOPLE_PATHS,
  ...PROD_SUPERVISOR_PRODUCTION_PATHS,
  ...PROD_SUPERVISOR_PROCESS_MODULE_PATHS,
])

/**
 * @param {string} pathname
 * @returns {boolean}
 */
export function isProdSupervisorPathAllowed(pathname) {
  const path = (pathname || '/').split('?')[0] || '/'
  if (PROD_SUPERVISOR_UTILITY_PATHS.has(path)) return true
  if (PROD_SUPERVISOR_MODULE_PATHS.has(path)) return true
  return false
}
